import React from "react";
import { FormattedRelativeTime } from "react-intl";
import moment from "moment";

interface UnitValuePair {
  unit: "second" | "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year" | undefined;
  value: number;
}

interface IIntlRelativeTimeProps {
  value: any;
  hideOlderThan?: UnitValuePair;
}

export default function IntlRelativeTime({ value, hideOlderThan }: IIntlRelativeTimeProps) {
  const { time, unit } = getTimeAndUnit(value);
  if (
    typeof hideOlderThan !== "undefined" &&
    hideOlderThan &&
    typeof unit !== "undefined" &&
    typeof hideOlderThan.unit !== "undefined" &&
    (compareUnits(unit, hideOlderThan.unit) < 0 ||
      (compareUnits(unit, hideOlderThan.unit) === 0 && Math.abs(time) >= hideOlderThan.value))
  ) {
    return null;
  }

  return <FormattedRelativeTime value={time} unit={unit} />;
}

type TTimeAndUnit = {
  time: number;
  unit: "second" | "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year" | undefined;
};

function getTimeAndUnit(value: any): TTimeAndUnit {
  const deltaYears = moment().diff(value, "year");
  const deltaMonths = moment().diff(value, "month");
  const deltaDays = moment().diff(value, "day");
  const deltaHours = moment().diff(value, "hour");
  const deltaMinutes = moment().diff(value, "minute");
  const deltaSeconds = moment().diff(value, "second");

  if (deltaYears > 0) {
    return {
      time: -deltaYears,
      unit: "year",
    };
  }

  if (deltaMonths > 0) {
    return {
      time: -deltaMonths,
      unit: "month",
    };
  }

  if (deltaDays > 0) {
    return {
      time: -deltaDays,
      unit: "day",
    };
  }

  if (deltaHours > 0) {
    return {
      time: -deltaHours,
      unit: "hour",
    };
  }

  if (deltaMinutes > 0) {
    return {
      time: -deltaMinutes,
      unit: "minute",
    };
  }

  return {
    time: -deltaSeconds,
    unit: "second",
  };
}

function compareUnits(
  unit: "second" | "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year",
  unitToCompare: "second" | "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year",
) {
  const weights = { second: 1, minute: 10, hour: 20, day: 30, week: 40, month: 50, quarter: 60, year: 70 };
  if (weights[unit] === weights[unitToCompare]) {
    return 0;
  }

  if (weights[unit] > weights[unitToCompare]) {
    return -1;
  }

  return 1;
}
